/**
 * @generated SignedSource<<278fc619e66229af1ff310956a56efa3>>
 * @relayHash 4df4ad1b1ffad946103f8563452b47c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dba303235470cee5fad84d2d3bf068b390e9a0f5d398db24a513a82c9b53a345

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useAudioContentQuery$variables = {
  contentId: string;
};
export type useAudioContentQuery$data = {
  readonly singleContent: {
    readonly emoji: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly value: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly history: {
      readonly createdBy: {
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
      readonly ownedBy: {
        readonly displayName: string | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly subType: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type useAudioContentQuery = {
  response: useAudioContentQuery$data;
  variables: useAudioContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "subType"
},
v5 = {
  "alias": "emoji",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "emoji-title-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(key:\"emoji-title-published\")"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAudioContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v8/*: any*/)
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAudioContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v9/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v9/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4df4ad1b1ffad946103f8563452b47c6",
    "id": "dba303235470cee5fad84d2d3bf068b390e9a0f5d398db24a513a82c9b53a345",
    "metadata": {},
    "name": "useAudioContentQuery",
    "operationKind": "query",
    "text": "query useAudioContentQuery($contentId:ID!){singleContent(id:$contentId){id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}}}"
  }
};
})();

(node as any).hash = "4c5e9cc35317f91214366a102267ee70";

export default node;
